import React, { useState } from 'react';
import axios from 'axios';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/banner/4.jpg');

const Recrutement = () => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        location: '',
        domaine: '',
        speciality: '',
        phoneNumber: '',
        CV: null
    });

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "CV") {
            setFormData(prev => ({ ...prev, CV: files[0] }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append('name', formData.name);
        data.append('description', formData.description);
        data.append('location', formData.location);
        data.append('domaine', formData.domaine);
        data.append('speciality', formData.speciality);
        data.append('phoneNumber', formData.phoneNumber);
        data.append('CV', formData.CV);

        try {
            await axios.post('https://alaussback-production.up.railway.app/api/recrutments', data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

        } catch (error) {

        }
    };

    return (
        <div dir="rtl">
            <Header />
            <div className="page-content">
                <Banner title="نحن نبحث عن مهندسين وبنائين ماهرين للانضمام إلى فريقنا " pagename="التوظيف" bgimage={bnrimg} />
                <div className="section-full p-tb80 inner-page-padding">
                    <div className="container">
                        <div className="section-content">
                            <div className="row">
                                <div className="col-md-8 col-sm-6">
                                    <form className="contact-form cons-contact-form" onSubmit={handleSubmit}>
                                        <div className="contact-one m-b30">
                                            <div className="section-head">
                                                <div className="mt-separator-outer separator-right">
                                                    <div className="mt-separator">
                                                        <h2 style={{ fontFamily: 'Cairo, sans-serif', textAlign: 'right' }} className="text-uppercase sep-line-one ">
                                                            <span className="font-weight-300 text-primary">تقدّم بطلبك </span> الان
                                                        </h2>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <input 
                                                    name="name" 
                                                    type="text" 
                                                    className="form-control" 
                                                    required 
                                                    placeholder="الإسم كامل" 
                                                    value={formData.name} 
                                                    onChange={handleChange}
                                                    style={{ textAlign: 'right', direction: 'rtl' }}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <input 
                                                    name="phoneNumber" 
                                                    type="number" 
                                                    className="form-control" 
                                                    required 
                                                    placeholder="رقم الهاتف" 
                                                    value={formData.phoneNumber} 
                                                    onChange={handleChange}
                                                    style={{ textAlign: 'right', direction: 'rtl' }}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <input 
                                                    name="location" 
                                                    type="text" 
                                                    className="form-control" 
                                                    required 
                                                    placeholder="العنوان" 
                                                    value={formData.location} 
                                                    onChange={handleChange}
                                                    style={{ textAlign: 'right', direction: 'rtl' }}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <input 
                                                    name="domaine" 
                                                    type="text" 
                                                    className="form-control" 
                                                    required 
                                                    placeholder="المجال" 
                                                    value={formData.domaine} 
                                                    onChange={handleChange}
                                                    style={{ textAlign: 'right', direction: 'rtl' }}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <input 
                                                    name="speciality" 
                                                    type="text" 
                                                    className="form-control" 
                                                    required 
                                                    placeholder="الإختصاص" 
                                                    value={formData.speciality} 
                                                    onChange={handleChange}
                                                    style={{ textAlign: 'right', direction: 'rtl' }}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <textarea 
                                                    name="description" 
                                                    rows={4} 
                                                    className="form-control" 
                                                    required 
                                                    placeholder="حدّثنا عن نفسك" 
                                                    value={formData.description} 
                                                    onChange={handleChange}
                                                    style={{ textAlign: 'right', direction: 'rtl' }}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label style={{ textAlign: 'right', display: 'block', fontFamily: 'Cairo, sans-serif' }}>السيرة الذاتيّة</label>
                                                <input 
                                                    name="CV" 
                                                    type="file" 
                                                    accept=".pdf,.doc,.docx" 
                                                    className="form-control" 
                                                    required 
                                                    onChange={handleChange}
                                                    style={{ direction: 'rtl' }}
                                                />
                                            </div>

                                            <div className="text-left">
                                                <button type="submit" className="site-button btn-effect">إرسال</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-md-4 col-sm-6" style={{ fontFamily: 'Cairo, sans-serif' }}> 
                                    <div className="contact-info m-b30">
                                        <div className="section-head">
                                            <div className="mt-separator-outer separator-right">
                                                <div className="mt-separator">
                                                    <h2 className="text-uppercase sep-line-one" style={{ fontFamily: 'Cairo, sans-serif', textAlign: 'right' }}>
                                                        <span className="font-weight-300 text-primary"></span> للإتصال بنا
                                                    </h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="bg-dark p-a20 text-white">
                                            <div className="mt-icon-box-wraper right p-b40">
                                                <div className="icon-xs" style={{ float: 'right', marginLeft: '15px', marginRight: '0' }}><i className="fa fa-phone" /></div>
                                                <div className="icon-content" style={{ textAlign: 'right' }}>
                                                    <h5 className="m-t0 font-weight-500" style={{ fontFamily: 'Cairo, sans-serif' }}>رقم الهاتف</h5>
                                                    <p>+966 920002674</p>
                                                </div>
                                            </div>
                                            <div className="mt-icon-box-wraper right p-b40">
                                                <div className="icon-xs" style={{ float: 'right', marginLeft: '15px', marginRight: '0' }}><i className="fa fa-envelope" /></div>
                                                <div className="icon-content" style={{ textAlign: 'right' }}>
                                                    <h5 className="m-t0 font-weight-500" style={{ fontFamily: 'Cairo, sans-serif' }}>الإيميل</h5>
                                                    <p>hr@alauss.com</p>
                                                </div>
                                            </div>
                                            <div className="mt-icon-box-wraper right">
                                                <div className="icon-xs" style={{ float: 'right', marginLeft: '15px', marginRight: '0' }}><i className="fa fa-map-marker" /></div>
                                                <div className="icon-content" style={{ textAlign: 'right' }}>
                                                    <h5 className="m-t0 font-weight-500" style={{ fontFamily: 'Cairo, sans-serif' }}>العنوان</h5>
                                                    <p style={{ fontFamily: 'Cairo, sans-serif' }}>المملكة العربية السعودية - الاحساء</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Recrutement;